import React, {createRef, useState, useEffect, useCallback} from "react";
import styled from "styled-components";
import { Button } from "@zebra-fed/zds-react-desktop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { NoDataMessage } from "../components/NoDataMessage";
import { capitaliseFirstLetter } from "../utils";

import { PageTitle } from "../styled-components/shared";
import {useTranslation} from "react-i18next";

const Card = styled.div`
  width: 100%;
  background: #007aba;
  opacity:  ${props => (props.important ? 0.7 : 0.4)};
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  color: white;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media screen and (max-width: 1000px) {
    height: 100%;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 700px) {
    height: 100%;
    flex-wrap: none;
    flex-direction: column;
  }
  margin-left: -12px;

  width: 100%;
  height: calc(100vw * 0.12);
`;

const LargeText = styled.div`
  font-size: 2.8em;
  font-weight: bold;
  @supports (-ms-ime-align: auto) {
    padding: 50px;
  };
`;

const LittleText = styled.div`
  font-size: 1em;
`;

export const RefreshText = styled.p`
  text-decoration: none;
  color: #007aba;
  color: ${props => (props.pStyle === "error" ? "#ED1C24" : "007ABA")};
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 0 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  p {
    margin-right: 24px;
  }
`;

const StyledDiv = styled.div`
  width: 100%;
  width: ${props => props.width}px;
  padding: 0 2vw;
  @media screen and (max-width: 1000px) {
    padding: 2vw;
    height: calc(100vw * 0.16);
  }
  @media screen and (max-width: 700px) {
    height: calc(0.4 * ${props => props.width}px);
  }
`;

export default function OverviewCard(props) {
  const ref = createRef(null);
  const [width, setWidth] = useState(document.body.clientWidth);

  const {t} = useTranslation()

  const handleScreenWidth = useCallback(() => {
    setWidth(document.body.clientWidth);
  }, [width]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.addEventListener("resize", handleScreenWidth);
    setWidth(ref.current.clientWidth);
    return function () {
      window.removeEventListener("resize", handleScreenWidth);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const Cards = props => {
    let cardSize =
      props.data && width / props.data.length - props.data.length + 1;
    if (width > 1000 && width < 1200) {
      let m = width - 350;
      cardSize = props.data && m / props.data.length - props.data.length + 1;
    }
    if (width < 700) {
      cardSize = width;
    }
    return (
      <CardWrapper>
        {!props.isLoading && props.data && props.data.length > 0 && width ? (
          props.data.map((cardData, index) => (
            <StyledDiv width={cardSize} key={`card-div-${index}`}>
              <Card
                key={`card-${cardData.toString()}`}
                important={Object.keys(cardData).toString() === props.important}
              >
                <LargeText key={`largeText-${cardData.toString()}`}>
                  {Object.values(cardData).toString()}
                </LargeText>
                <LittleText key={`littleText-${cardData.toString()}`}>
                  {" "}
                  {
                    capitaliseFirstLetter(t(Object.keys(cardData).toString()))
                  }
                </LittleText>
              </Card>
            </StyledDiv>
          ))
        ) : !props.isLoading && (!props.data || props.data.length === 0) ? (
          <NoDataMessage>{t('messages.error.err42')}</NoDataMessage>
        ) : (
          <CircularProgress />
        )}
      </CardWrapper>
    );
  };
  return (
    <>
      <PageTitle ref={ref}>
        {props.title ? props.title : t('overview')}
        <ButtonWrapper>
          {props.preButtonData && (
            <RefreshText pStyle={props.preButtonStyle}>
              {props.preButtonData}
            </RefreshText>
          )}
          {props.onClick && (
            <Button
              type="primary"
              dense={true}
              style={{ margin: 0 }}
              onClick={() => props.onClick()}
            >
              {t(props.buttonText?props.buttonText:'syncLicenses')}
            </Button>
          )}
        </ButtonWrapper>
      </PageTitle>

      <Cards
        data={props.data}
        isLoading={props.isLoading}
        important={props.important}
      />
    </>
  );
}